var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMushroomAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.26 5.97293C19.7101 6.60237 18.9015 7 18 7C16.3431 7 15 5.65685 15 4C15 3.4687 15.1381 2.96966 15.3804 2.53683C14.3236 2.18923 13.1857 2 12 2C6.91593 2 2.71015 5.47917 2.01256 10.0039C1.90031 10.7331 2.55638 11.3333 3.35232 11.3333H9.11744V12.9264C9.11744 14.5273 8.9466 16.1237 8.60722 17.6934L8.52418 18.0775C8.08539 20.1068 9.76313 22 12 22C14.2369 22 15.9146 20.1068 15.4758 18.0775L15.3928 17.6934C15.0534 16.1237 14.8826 14.5273 14.8826 12.9264V11.3333H20.6477C21.4436 11.3333 22.0997 10.7331 21.9874 10.0039C21.7585 8.51896 21.1517 7.14663 20.26 5.97293ZM14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8ZM6.5 7C5.67157 7 5 6.32843 5 5.5C5 4.67157 5.67157 4 6.5 4C7.32843 4 8 4.67157 8 5.5C8 6.32843 7.32843 7 6.5 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMushroomAlt);
export default __webpack_public_path__ + "static/media/mushroom-alt.c5110d61c1c5da10f4f311f4124c6608.svg";
export { ForwardRef as ReactComponent };